import { useMemo } from "react";
import useSubscription from "hooks/useSubscription";

/**
 * Custom hook to determine if the organisation's subscription is in a trial state.
 */
function useSubscriptionInTrial() {
  const subscription = useSubscription();

  /**
   * Determines if the organisation is currently in a trial period without a card payment method enabled.
   * - if subscription is undefined, returns false.
   * - if subscription status is not "Trialing", returns false.
   * - if trialEndDate is null or undefined, returns false.
   * - if hasCardPaymentMethod is true, returns false. Meaning a card payment method is enabled for the subscription.
   * - otherwise, returns true.
   */
  return useMemo(() => {
    // early return if subscription is undefined
    if (!subscription) return false;
    return (
      subscription.status === "Trialing" &&
      Boolean(subscription.trialEndDate) &&
      subscription.hasCardPaymentMethod === false
    );
  }, [subscription]);
}

export default useSubscriptionInTrial;
